import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
	Signal,
	ViewEncapsulation,
	signal,
} from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

interface Scope {
	loading: Signal<boolean>;
}

@Component({
	selector: 'ms-input-password',
	templateUrl: './ms-input-password.component.html',
	styleUrls: ['./ms-input-password.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class MsInputPasswordComponent implements OnInit, OnDestroy {
	@Input() formGroup: FormGroup;
	@Input() title: string;
	@Input() key: string;
	@Input() placeholder: string;
	@Input() titleFieldEquals: string;

	scope: Scope = {
		loading: signal(true),
	};

	/**
	 * Constructor
	 */
	constructor(private _formBuilder: UntypedFormBuilder) {
		this.scope.loading = signal(false);
		if (!this.formGroup) {
			this.formGroup = this._formBuilder.group({
				name: [null, [Validators.required]],
			});
		}
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {
		if (!this.placeholder) {
			this.placeholder = this.title;
		}
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------
}
